/* Generado por el instalador. No editar a mano. */
import { lazy } from 'react';
export const MUSIC_INSTALLED = true;

export const MusicSystem = lazy(() => import('../pages/MusicSystem'));
export { default as SonosSpeakerCard } from '../components/sonos/SonosSpeakerCard';
export { default as SonosSpeakerModal } from '../components/sonos/SonosSpeakerModal';
export { cargarSonos } from '../services/sonosState';
export { mapaSonos } from '../services/sonosState';
export { refrescarSonos } from '../services/sonosState';
export { getSonosByHabitacion } from '../services/sonosState';
export { sonosControl } from '../services/sonosApi';
export { getFavorites } from '../services/sonosApi';
export { getSonosFavoritesOrden } from '../services/sonosApi';
export { addFavorite } from '../services/sonosApi';
export { removeFavorite } from '../services/sonosApi';
export type { SonosSpeaker } from '../services/sonosApi';
export function preload_MusicSystem() { return import('../pages/MusicSystem'); }
export { deleteSonosSpeaker } from '../services/sonosApi';
export { mergeSonosSpeakers } from '../services/sonosState';
export { updateSonosFavoritesOrder } from '../services/sonosApi';
export { default as SonosDefaultEqAdminSection } from '../components/sonos/SonosDefaultEqAdminSection';
export { fetchSonosSpeakers } from '../services/sonosApi';
export { patchSonosSpeaker } from '../services/sonosApi';
export { reorderSonosSpeakers } from '../services/sonosApi';
export { isSonosPlaying } from '../services/sonosApi';
export { refrescarSonosPorIds } from '../services/sonosState';
export { getRecentPlaylists } from '../services/sonosApi';
export { getSpotifyPlaylists } from '../services/sonosApi';
export { playSpotifyOnSpeaker } from '../services/sonosApi';
export { playSpotifyTrack } from '../services/sonosApi';
export { spotifySearch } from '../services/sonosApi';
export type { SpotifyPlaylist } from '../services/sonosApi';
export { default as SonosDiscoveryTab } from '../components/sonos/SonosDiscoveryTab';
export { default as SonosSpeakerCardSettings } from '../components/sonos/SonosSpeakerCardSettings';
export { fetchWebPlaybackToken } from '../services/sonosApi';
export { spotifyConnectAddToQueue } from '../services/sonosApi';
export { spotifyConnectNext } from '../services/sonosApi';
export { spotifyConnectPause } from '../services/sonosApi';
export { spotifyConnectPlay } from '../services/sonosApi';
export { spotifyConnectSeek } from '../services/sonosApi';
export { spotifyConnectTransfer } from '../services/sonosApi';
export { spotifyConnectVolume } from '../services/sonosApi';
export { artifactTypeLineSx } from '../components/sonos/sonosCardLayout';
export { sonosCardOuterSx } from '../components/sonos/sonosCardLayout';
